import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'
import Text from '../../Text'

const SectionHeader = (props) => {
  const { title } = props

  return (
    <Box marginY="large">
      <Text color="faintGrey" fontSize="11px" letterSpacing="1px">{title}</Text>
    </Box>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.string,
}

export default SectionHeader
